import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import updateOrganisationRoleService from '../services/updateOrganisationRoleService';
import organisationRoleService from '../services/organisationRoleService';
import OrganisationRoleForm from './OrganisationRoleForm';
import { mapFormToValues, mapValuesToForm } from '../helpers/mapValues';

const EditOrganisationRole = ({
  open,
  dispatchUpdateOrganisationRolePut,
  updateOrganisationRoleFetch,
  dispatchOrganisationRoleGet,
  organisationRoleFetch,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tag } = useParams();

  const handleSubmit = useCallback(
    body =>
      dispatchUpdateOrganisationRolePut(
        tag,
        mapFormToValues(body),
        () => navigate(`/organisation-roles`),
        t
      ),
    [tag, dispatchUpdateOrganisationRolePut, t, navigate]
  );

  useEffect(() => {
    if (open && tag) {
      dispatchOrganisationRoleGet(tag, () => navigate('/organisation-roles'), t);
    }
  }, [tag, open, t, dispatchOrganisationRoleGet, navigate]);

  if (!open) return null;

  return (
    <OrganisationRoleForm
      header={organisationRoleFetch.value?.name}
      onSubmit={handleSubmit}
      submitProcessing={updateOrganisationRoleFetch.pending}
      returnRoute="/organisation-roles"
      cancelRoute="/organisation-roles"
      dataLoading={organisationRoleFetch.pending}
      data={!organisationRoleFetch.pending && mapValuesToForm(organisationRoleFetch.value)}
      showRemoveButton
      editMode
    />
  );
};

EditOrganisationRole.propTypes = {
  dispatchUpdateOrganisationRolePut: PropTypes.func.isRequired,
  updateOrganisationRoleFetch: PropTypes.object.isRequired,
  dispatchOrganisationRoleGet: PropTypes.func.isRequired,
  organisationRoleFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

EditOrganisationRole.defaultProps = { open: false };

export default compose(
  organisationRoleService,
  updateOrganisationRoleService
)(EditOrganisationRole);
